import { JSX } from 'react';
import { useCustomSitecoreContext } from 'src/shared/useCustomSitecoreContext';
import { S02FindALocationProps } from './S02FindALocation.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { CreateFindALocationModel } from './S02FindALocation.service';
import { FindALocation } from '@ahc-digital/component-library';
import { useEffect, useState } from 'react';
import { fetchSpecialityList } from 'src/shared/ReputationLocatorApi.service';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { GetServerSideComponentProps } from '@sitecore-jss/sitecore-jss-nextjs';
import { LayoutServiceDataExtensions } from 'src/shared/shared.types';
import { GetGoogleMapAPI } from 'src/shared/GoogleMap.service';

const Default = (props?: S02FindALocationProps): JSX.Element => {
  const { googleMapsAPIKey = '' } = props || {};
  const [options, setOptions] = useState({});
  const context = useCustomSitecoreContext();
  const reputationLocationSearchID = context?.reputationLocationSearchID?.value;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  useEffect(() => {
    async function fetchOptions() {
      try {
        const response = reputationLocationSearchID
          ? await fetchSpecialityList(
              reputationLocationSearchID,
              props?.fields?.FilterType?.value ?? ''
            )
          : {};
        setOptions(response);
      } catch (error) {
        console.error('Error fetching options:', error);
      }
    }
    fetchOptions();
  }, [reputationLocationSearchID, props?.fields?.FilterType?.value]);

  const locationSearchURL: string = context?.locationSearchURL?.value ?? '';

  return (
    <FindALocation
      {...CreateFindALocationModel(props, locationSearchURL, options)}
      className={translationClasses(props?.params)}
      googleMapsAPIKey={googleMapsAPIKey}
      data-component={marketingRenderingName}
    />
  );
};

export default checkDatasourceForRendering<S02FindALocationProps>(Default);

export const getServerSideProps: GetServerSideComponentProps = async (_rendering, layoutData) => {
  const context = layoutData.sitecore.context as LayoutServiceDataExtensions['context'];
  return {
    googleMapsAPIKey: GetGoogleMapAPI(context?.envVariableNameForGoogleMapAPI?.value || ''),
  };
};
